/* 🤖 this file was generated by svg-to-ts */
export const iconExoduswallet: {
  name: 'exoduswallet';
  data: string;
} = {
  name: 'exoduswallet',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="currentColor" d="M16 0C7.16 0 0 7.16 0 16s7.16 16 16 16 16-7.16 16-16S24.84 0 16 0m-1.47 27.42-9.75-6.36L6.37 16l-1.59-5.06 9.73-6.38v3.57l-6.22 4.06.71 2.32h5.51v2.96H9.02l-.73 2.32 6.24 4.06zm12.69-6.36-9.73 6.36v-3.57l6.24-4.06-.73-2.32h-5.51v-2.96H23l.73-2.32-6.24-4.06V4.56l9.73 6.38L25.63 16z"/></svg>`,
};
